module.exports = __webpack_public_path__ + "img/f-51-round.55715365.png";